//@ts-nocheck
import React, { useState, useEffect } from "react";
import Client from "shopify-buy";
import { getLocalState } from "../helper/local-storage";
import { setSessionState } from "../helper/session-storage";
import { CART_PRODUCTS } from "./local-cart-provider";
import {
  createCart,
  addCartLines,
  updateCartAttributes,
  updateCartNote,
  updateCartBuyerIdentity,
  getCustomerToken,
} from "../helper/shop-queries";

const client = Client.buildClient({
  storefrontAccessToken: process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
  domain: `${process.env.GATSBY_SHOP_NAME}.myshopify.com`,
});

export const CartContext = React.createContext();

const CartProvider = ({ children }) => {
  const initialStoreState = {
    client,
    updating: false,
    checkout: { id: null, lineItems: [] },
    products: [],
    shop: {},
    customerToken: null,
  };

  const [store, updateStore] = useState(initialStoreState);
  const [initialize, setInitialize] = useState(false);

  useEffect(() => {
    const initializeCheckout = async () => {
      const newCart = await createCart();
      if (newCart) {
        updateStore((prevState) => ({ ...prevState, checkout: newCart }));
      }
    };

    const initializeCustomerToken = async () => {
      const customerToken = await getCustomerToken();
      if (customerToken) {
        updateStore((prevState) => ({ ...prevState, customerToken }));
      }
    };

    initializeCustomerToken();
    initializeCheckout();
  }, [initialize]);

  return (
    <CartContext.Provider
      value={{
        store,
        addToCartAndCheckout: async (deliveryDate, note) => {
          updateStore((prevState) => ({ ...prevState, updating: true }));
          const products = getLocalState(CART_PRODUCTS);
          const lineItemsToUpdate = products.map((product) => ({
            merchandiseId: product.variantId,
            quantity: product.quantity,
          }));

          const normalizedNote = note
            ? note.replace(/[\r\n"]+/g, " ").replace(/"/g, "'")
            : "";

          let cart = store.checkout;
          if (!cart || !cart.id) {
            const newCart = await createCart();
            cart = newCart || cart;
          }

          if (!cart || !cart.id) {
            updateStore((prevState) => ({ ...prevState, updating: false }));
            return;
          }

          if (lineItemsToUpdate.length) {
            const addLinesResult = await addCartLines(cart.id, lineItemsToUpdate);
            cart = addLinesResult?.cart || cart;
          }

          const attributes = [{ key: "DeliveryDate", value: deliveryDate }];
          const updateAttributesResult = await updateCartAttributes(cart.id, attributes);
          cart = updateAttributesResult?.cart || cart;

          if (normalizedNote) {
            const updateNoteResult = await updateCartNote(cart.id, normalizedNote);
            cart = updateNoteResult?.cart || cart;
          }

          if (store.customerToken) {
            const buyerIdentityResult = await updateCartBuyerIdentity(
              cart.id,
              store.customerToken
            );
            cart = buyerIdentityResult?.cart || cart;
          }

          if (cart?.checkoutUrl) {
            setSessionState("checkoutId", cart.id);
            window.open(
              cart.checkoutUrl
                .replace(`${process.env.GATSBY_SHOP_NAME}.myshopify.com`, process.env.SHOP_DOMAIN_NAME)
                .replace("&channel=buy_button", ""),
              "_self"
            );
          }

          setInitialize(Date.now());
          updateStore((prevState) => ({
            ...prevState,
            checkout: cart,
            updating: false,
          }));
        },
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
